import Vue from 'vue'
import Vuex from 'vuex'
import api from '../services/api'

import auth from './auth'
import firebaseAuth from './firebase'

Vue.use(Vuex)

const store = new Vuex.Store({
    // strict: true,
    devtools: false,
    namespaced: true,
    state: {
        isStoreReady: false,
        empresaSelecionada: null,
        empresaFollowUp: null
    },

    mutations: {
        setStoreReady(state, ready) {
            state.isStoreReady = ready
        },
        setEmpresaSelecionada(state, empresa) {
            state.empresaSelecionada = empresa
            // Limpar cache do follow-up quando empresa muda
            state.empresaFollowUp = null

            // Persist to localStorage
            if (empresa) {
                localStorage.setItem('empresaSelecionada', JSON.stringify(empresa))
            } else {
                localStorage.removeItem('empresaSelecionada')
            }
        },
        setEmpresaFollowUp(state, followUpAtivo) {
            state.empresaFollowUp = followUpAtivo
        }
    },

    actions: {
        getAuth(state) {
            return state.isAuth
        },
        restoreEmpresa({ commit }) {
            const empresa = localStorage.getItem('empresaSelecionada')

            if (empresa) {
                try {
                    commit('setEmpresaSelecionada', JSON.parse(empresa))
                    return true
                } catch (error) {
                    localStorage.removeItem('empresaSelecionada')
                    return false
                }
            }

            return false
        },
        async reloadEmpresaConfig({ commit }, idEmpresa) {
            const response = await api.get(`web-cliente/empresa/${idEmpresa}/config`)
            commit('setEmpresaSelecionada', response.data)
        },
        async fetchEmpresaFollowUp({ commit, state }, idEmpresa) {
            // Se já está em cache, retorna o valor
            if (state.empresaFollowUp !== null) {
                return state.empresaFollowUp
            }

            try {
                const response = await api.get(`web-cliente/follow-up/status/${idEmpresa}`)
                const followUpAtivo = response.data.followUpAtivo

                // Salva no cache
                commit('setEmpresaFollowUp', followUpAtivo)

                return followUpAtivo
            } catch (error) {
                console.error('[STORE] Erro ao verificar status do follow-up da empresa:', error)

                // Em caso de erro, assume false e salva no cache
                commit('setEmpresaFollowUp', false)
                return false
            }
        }
    },


    modules: {
        auth: auth,
        firebaseAuth: firebaseAuth

    }
})

export default store